export var TypeGrantRewards;
(function (TypeGrantRewards) {
    TypeGrantRewards[TypeGrantRewards["Doghouse"] = 0] = "Doghouse";
    TypeGrantRewards[TypeGrantRewards["Shop"] = 1] = "Shop";
    TypeGrantRewards[TypeGrantRewards["Chest"] = 2] = "Chest";
    TypeGrantRewards[TypeGrantRewards["FortuneTeller"] = 3] = "FortuneTeller";
})(TypeGrantRewards || (TypeGrantRewards = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/grant-rewards/TypeGrantRewards.ts
// module id = 288
// module chunks = 3